import { render, staticRenderFns } from "./guanhuFooter.vue?vue&type=template&id=e5eaf9bc&scoped=true&"
import script from "./guanhuFooter.vue?vue&type=script&lang=js&"
export * from "./guanhuFooter.vue?vue&type=script&lang=js&"
import style0 from "./guanhuFooter.vue?vue&type=style&index=0&id=e5eaf9bc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5eaf9bc",
  null
  
)

export default component.exports